import { callApi } from '../common/services/baseServices';
import { host } from '../environment';
import { getCookie } from '../common/enum';
import moment from 'moment';
// import { dataDummy } from './data';

const ACTIONS = {
    GET_PLAYLOG_SEARCH_SUCCESS : 'GET_PLAYLOG_SEARCH_SUCCESS',
    GET_PLAYLOG_SEARCH_ERROR : 'GET_PLAYLOG_SEARCH_ERROR',
    GET_GAMES_SUCCESS : 'GET_GAMES_SUCCESS',
    GET_GAMES_ERROR : 'GET_GAMES_ERROR'
};

const updateStatus = (type, data) => ({
    type,
    data,
});

const getGames = (data) => {
    const config = {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${localStorage.getItem('ACCESS_TOKEN') || getCookie('ACCESS_TOKEN')}`,
        },
    };
    let url = `${host.serverTest}api/games/years/${data.year_id}/months/${data.month || ''}`;
    return (dispatch) => {
        callApi(url, config,
            (data) => {

                if (data.error) {
                    dispatch(updateStatus(ACTIONS.GET_GAMES_ERROR, data.error));
                } else {
                    dispatch(updateStatus(ACTIONS.GET_GAMES_SUCCESS, data));
                }
            },
            (err) => {
                dispatch(updateStatus(ACTIONS.GET_GAMES_ERROR, err));
            });
    };
};

const getPlaylogSearch = (data) => {
    const config = {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${localStorage.getItem('ACCESS_TOKEN') || getCookie('ACCESS_TOKEN')}`,
        },
    };

    let url = `${host.serverTest}api/playlog?year_id=${data.year_id || ''}&month=${data.month || ''}&game_id=${data.game_id || ''}&pitcher_id=${data.pitcher_id || ''}&batter_id=${data.batter_id || ''}&sort=${data.sort || ''}&order=${data.order || ''}`;
    return (dispatch) => {
        callApi(url, config,
            (data) => {
                // console.log(data);

                if (data.error) {
                    dispatch(updateStatus(ACTIONS.GET_PLAYLOG_SEARCH_ERROR, data.error));
                } else {
                    dispatch(updateStatus(ACTIONS.GET_PLAYLOG_SEARCH_SUCCESS, data));
                }
            },
            (err) => {
                dispatch(updateStatus(ACTIONS.GET_PLAYLOG_SEARCH_ERROR, err));
            });
    };
};

// convert
const convertDataPlaylogSearch = (data) => {
    if (data) {
        const arr = data.map(items => {
            if (items.game) {
                return {
                    item: [

                        { text: items.game.game_date },
                        { text: items.game.stadium_name },
                        {
                            text: items.game.home_team.team_name_s,
                            url: '/game/' + items.game.id + "/" + items.game.home_team.id + "/" + moment(items.game.game_date, "YYYY/MM/DD").format('YYYYMMDD'),
                            link: true
                        },
                        {
                            text: items.game.away_team.team_name_s,
                            url: '/game/' + items.game.id + "/" + items.game.away_team.id + "/" + moment(items.game.game_date, "YYYY/MM/DD").format('YYYYMMDD'),
                            link: true
                        },
                        { text: `${items.inning}回${items.top_bottom}`},
                        { text: items.pa_of_inning },
                        { text: items.pitcher.player_name },
                        { text: items.batter.player_name },
                        { text: items.play_result }
                    ]
                }
            }
        });
        return arr;
    }
}

export {
    ACTIONS, getGames, getPlaylogSearch, convertDataPlaylogSearch
};
